/**
 * Created by Ivan on 17.05.2026
 */

(function () {
    const original = MissionsTool.getMissionMenu;

    MissionsTool.getMissionMenu = function (mission) {
        const actions = original.call(this, mission);
        if (mission.type !== Mission.TYPE_SEASON_PASS) {
            return actions;
        }

        const logic = mission.logic;

        actions.openWindow = displayToolWindow(() => new SeasonPassWindow(mission));
        actions.openStartWindow = displayToolWindow(() => new SeasonPassStartWindow(mission));
        actions.openStartWindowFallback = displayToolWindow(() => new SeasonPassStartWindowFallback(mission));
        actions.openNewTasksWindow = displayToolWindow(() => new SeasonPassNewTasksWindow(mission));
        actions.openCompletedTasksWindow = displayToolWindow(() => {
            logic.questPack.getActiveQuests().forEach((q) => q.addProgress(q.goal));
            new SeasonPassCompletedTasksWindow(mission);
        });
        actions.openPointsReward = displayToolWindow(() => {
            logic.awardPoints(100);
            new SeasonPassWindow(mission);
        });
        actions.openUnitLibraryWindow = displayToolWindow(() => new SeasonPassUnitLibraryWindow(mission));
        actions.openLastChanceWindow = displayToolWindow(() => new SeasonPassLastChanceWindow(mission, true));
        actions.openPurchaseWindow = displayToolWindow(() => new SeasonPassPurchaseWindow(mission));
        actions.openConfirmationWindow = displayToolWindow(() => new SeasonPassConfirmationWindow(mission, {
            onGiveUp: () => cleverapps.notification.create("Give up"),
            onRethink: () => cleverapps.notification.create("Rethink")
        }));
        actions.openFinishWindow = displayToolWindow(() => new SeasonPassFinishWindow(mission));
        actions.openFinishWindowFallback = displayToolWindow(() => new SeasonPassFinishWindowFallback(mission));

        actions.addPoints25 = function () {
            logic.addPoints(25);
        };
        actions.addPoints100 = function () {
            logic.addPoints(100);
        };
        actions.addPoints500 = function () {
            logic.addPoints(500);
        };
        actions.addPoints10000 = function () {
            logic.addPoints(10000);
        };
        actions.unlockVip = function () {
            logic.unlockVip();
        };
        actions.unlockSuper = function () {
            logic.unlockVip();
            logic.unlockSuper();
        };
        actions.resetDay = function () {
            logic.questPack.resetDaily();
        };
        actions.resetNudges = function () {
            logic.markNudges(0);
        };
        // a season day for the nudges, and the day's tasks drawn anew as a real new day would
        const setSeasonDay = function (day) {
            mission.started = Date.now() - cleverapps.parseInterval(`${day - 1} days`);
            mission.onChanged();
            logic.questPack.resetDaily();
        };
        // the clock moves a day, so the season day, the nudges and the day's task group all follow; the
        // midnight refresh timer does not fire under a shift, hence the explicit reset
        actions.nextDay = function () {
            DateShift.setShift(DateShift.getDelta() + cleverapps.parseInterval("1 day"));
            logic.questPack.resetDaily();
        };
        actions.setSeasonDay10 = function () {
            setSeasonDay(10);
        };
        actions.setSeasonDay20 = function () {
            setSeasonDay(20);
        };
        actions.completePack = function () {
            const types = [...new Set(logic.questPack.getActiveQuests().filter((q) => !q.isFinished()).map((q) => q.type))];
            types.forEach((type) => {
                logic.questPack.applyProgress(type, Number.MAX_SAFE_INTEGER);
            });
        };
        actions.skipToFinalStage = function () {
            logic.stage = SeasonPassLogic.STAGES_AMOUNT - 1;
            logic.points = 0;
            logic.trigger("updateProgress");
            mission.update();
        };
        actions.makeChestReady = function () {
            logic.unlockVip();
            logic.unlockSuper();
            logic.stage = SeasonPassLogic.STAGES_AMOUNT - 1;
            logic.points = logic.getChestThreshold();
            logic.trigger("updateProgress");
            mission.update();
        };
        actions.resetProgress = function () {
            logic.stage = 0;
            logic.points = 0;
            logic.claimed = 0;
            logic.claimedVip = 0;
            logic.vip = 0;
            logic.chestClaims = 0;
            logic.nudges = 0;
            logic.questPack.load({});
            logic.trigger("updateProgress");
            mission.update();
        };

        return actions;
    };
}());

cleverapps.Tool.seasonPass = ToolFolder.create(() => {
    const startSeason = function (shift) {
        const mission = cleverapps.missionManager.findByType(Mission.TYPE_SEASON_PASS);
        if (mission) {
            cleverapps.missionManager.remove(mission);
        }

        DateShift.setShift(shift);

        if (!SeasonPassLogic.getPeriod()) {
            return;
        }

        cleverapps.missionManager.planMission(Mission.TYPE_SEASON_PASS);

        cleverapps.focusManager.whenFreeFocus(() => {
            cleverapps.placements.run(Placements.FREE_FOCUS, {
                skipDelayFromStart: true
            });
        });
    };

    const seasons = {};

    cleverapps.eventManager.listFeatureEvents("season_pass").filter((event) => !event.tool).forEach((event) => {
        seasons[`start${SeasonPassHelper.capitalize(event.options.period)}`] = () => {
            startSeason(event.start.getTime() - DateShift.Date.now());
        };
    });

    seasons.resetToNow = () => {
        startSeason(0);
    };

    return seasons;
});
